/* FURRMACY · interactions (§12 motion & states, §13 a11y) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.documentElement.classList.add('fm-reveal');

  /* ---------- Header: separate collapse and expand thresholds ---------- */
  function initHeader(root) {
    var header = root.querySelector('[data-fm-header]');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';
    var ticking = false;
    function update() {
      // Resizing this sticky header also moves the browser's scroll anchor.
      // Keep an 80px gap (larger than the 40-52px height change) so it cannot
      // trigger its own opposite state when the visitor stops scrolling.
      var condensed = header.classList.contains('is-condensed');
      var scrollY = Math.max(0, window.scrollY);
      if (!condensed && scrollY > 120) header.classList.add('is-condensed');
      else if (condensed && scrollY <= 40) header.classList.remove('is-condensed');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();

    var drawer = root.querySelector('[data-fm-drawer]');
    var openBtn = header.querySelector('[data-fm-drawer-open]');
    if (!drawer || !openBtn) return;
    var panel = drawer.querySelector('.fm-drawer__panel');
    var lastFocus = null;
    function focusables() { return panel.querySelectorAll('a[href],button:not([disabled])'); }
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var f = focusables(); if (f.length) f[0].focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 280);
      if (lastFocus) lastFocus.focus();
    }
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-fm-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Hero carousel: 700ms crossfade, 7s autoplay, pause on hover/focus ---------- */
  function initHero(el) {
    if (el.dataset.bound) return; el.dataset.bound = '1';
    var slides = el.querySelectorAll('[data-fm-slide]');
    if (slides.length < 2) { var bar = el.querySelector('.fm-hero__controls'); if (bar) bar.hidden = true; return; }
    var idx = Math.max(0, Array.prototype.findIndex.call(slides, function (s) { return s.classList.contains('is-active'); }));
    var label = el.querySelector('[data-fm-slide-label]');
    var live = el.querySelector('[data-fm-live]');
    var pauseBtn = el.querySelector('[data-fm-pause]');
    var userPaused = reduce.matches, hoverPaused = false, timer = null;
    el.dataset.paused = String(userPaused);
    function show(n, announce) {
      slides[idx].classList.remove('is-active'); slides[idx].setAttribute('aria-hidden', 'true'); slides[idx].inert = true;
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('is-active'); slides[idx].removeAttribute('aria-hidden'); slides[idx].inert = false;
      if (label) {
        label.textContent = '';
        var b = document.createElement('b'); b.textContent = slides[idx].dataset.num;
        var sp = document.createElement('span'); sp.textContent = slides[idx].dataset.title;
        label.appendChild(b); label.appendChild(sp);
      }
      if (announce && live) live.textContent = 'Slide ' + (idx + 1) + ' of ' + slides.length + ': ' + slides[idx].dataset.title;
    }
    function schedule() {
      clearInterval(timer);
      if (!userPaused && !hoverPaused) timer = setInterval(function () { show(idx + 1, false); }, 7000);
    }
    slides.forEach(function (s, i) { if (i !== idx) { s.setAttribute('aria-hidden', 'true'); s.inert = true; } });
    el.querySelector('[data-fm-prev]').addEventListener('click', function () { show(idx - 1, true); schedule(); });
    el.querySelector('[data-fm-next]').addEventListener('click', function () { show(idx + 1, true); schedule(); });
    pauseBtn.addEventListener('click', function () {
      userPaused = !userPaused; el.dataset.paused = String(userPaused);
      pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
      schedule();
    });
    pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
    el.addEventListener('mouseenter', function () { hoverPaused = true; schedule(); });
    el.addEventListener('mouseleave', function () { hoverPaused = false; schedule(); });
    el.addEventListener('focusin', function () { hoverPaused = true; schedule(); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { hoverPaused = false; schedule(); } });
    schedule();
  }

  /* ---------- Chip filters (products / articles): 120ms state, 180ms fade, no reflow animation ---------- */
  function initFilter(el) {
    if (el.dataset.bound) return; el.dataset.bound = '1';
    var chips = el.querySelectorAll('[data-fm-chip]');
    var items = el.querySelectorAll('[data-fm-tags]');
    var grid = el.querySelector('[data-fm-filter-grid]');
    var count = el.querySelector('[data-fm-count]');
    var singular = count ? count.dataset.singular : '';
    var plural = count ? count.dataset.plural : '';
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var val = chip.dataset.fmChip;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        var n = 0;
        items.forEach(function (it) {
          var tags = (' ' + it.dataset.fmTags + ' ');
          var show = val === 'all' || tags.indexOf(' ' + val + ' ') > -1;
          it.classList.toggle('is-filtered-out', !show);
          if (show) n++;
        });
        if (grid) { grid.classList.remove('is-refreshing'); void grid.offsetWidth; grid.classList.add('is-refreshing'); }
        if (count && plural) count.textContent = n + ' ' + (n === 1 ? singular : plural);
      });
    });
  }

  /* ---------- Accordions: single-open on mobile (FAQ), aria-expanded mirror ---------- */
  function initAccordion(el) {
    if (el.dataset.bound) return; el.dataset.bound = '1';
    var items = el.querySelectorAll('details');
    items.forEach(function (d) {
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', String(d.open));
      d.addEventListener('toggle', function () {
        if (s) s.setAttribute('aria-expanded', String(d.open));
        var single = el.hasAttribute('data-fm-single') || window.matchMedia('(max-width: 767px)').matches;
        if (d.open && single) items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  }

  /* ---------- FAQ TOC current state ---------- */
  function initToc(el) {
    if (el.dataset.bound || !('IntersectionObserver' in window)) return; el.dataset.bound = '1';
    var links = el.querySelectorAll('a[href^="#"]');
    var map = {};
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) map[t.id] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && map[en.target.id]) {
          links.forEach(function (l) { l.removeAttribute('aria-current'); });
          map[en.target.id].setAttribute('aria-current', 'true');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  /* ---------- Science: concern switcher ---------- */
  function initConcerns(el) {
    if (el.dataset.bound) return; el.dataset.bound = '1';
    var cards = el.querySelectorAll('[data-fm-concern]');
    var panels = el.querySelectorAll('[data-fm-concern-panel]');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var key = card.dataset.fmConcern;
        cards.forEach(function (c) {
          var on = c === card;
          c.setAttribute('aria-pressed', String(on));
          var st = c.querySelector('[data-fm-state]');
          if (st) st.textContent = on ? st.dataset.on : st.dataset.off;
        });
        panels.forEach(function (p) {
          var on = p.dataset.fmConcernPanel === key;
          p.hidden = !on;
          if (on) { p.classList.remove('is-switching'); void p.offsetWidth; p.classList.add('is-switching'); }
        });
        if (window.matchMedia('(max-width: 767px)').matches) {
          var activePanel = el.querySelector('[data-fm-concern-panel="' + key + '"]');
          if (activePanel) activePanel.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
    // Research summaries can return to the corresponding concern.
    var requestedConcern = new URLSearchParams(window.location.search).get('concern');
    if (/^[1-4]$/.test(requestedConcern || '')) {
      cards.forEach(function (card) {
        if (card.dataset.fmConcern === requestedConcern) card.click();
      });
    }
    el.querySelectorAll('[data-fm-concern-back]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var target = el.querySelector('[data-fm-concern-list]');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' }); var f = target.querySelector('[aria-pressed="true"]'); if (f) f.focus({ preventScroll: true }); }
      });
    });
  }

  /* ---------- Contact: move focus to success message ---------- */
  function initContact(el) {
    var msg = el.querySelector('[data-fm-success]');
    if (msg) { msg.focus(); }
  }

  /* ---------- Scroll reveal: section heads & card rows, 60ms stagger (max 4) ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (!els.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-revealed'); }); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-revealed');
        obs.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) {
      var parent = e.parentElement; if (!parent) return;
      var sibs = Array.prototype.filter.call(parent.children, function (c) { return c.hasAttribute('data-reveal'); });
      var i = sibs.indexOf(e); if (i > 0) e.style.setProperty('--reveal-delay', (Math.min(i, 4) * 60) + 'ms');
      io.observe(e);
    });
  }

  function init(root) {
    root = root || document;
    initHeader(document);
    root.querySelectorAll('[data-fm-hero]').forEach(initHero);
    root.querySelectorAll('[data-fm-filter]').forEach(initFilter);
    root.querySelectorAll('[data-fm-accordion]').forEach(initAccordion);
    root.querySelectorAll('[data-fm-toc]').forEach(initToc);
    root.querySelectorAll('[data-fm-concerns]').forEach(initConcerns);
    root.querySelectorAll('[data-fm-contact]').forEach(initContact);
    initReveal(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();